// QRGeneratorCardWrapper >> QRGeneratorTable >> QRGeneratorTableIcons >> LiteCreateQRModal >> LiteForm
import { Box, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { bindActionCreators } from 'redux';
import { useAppDispatch } from '../../store/hooks';
import { createNewRedirect } from '../../store/slices/redirectSlice';
import { FlatButton } from '../Buttons/FlatButton';
import { LiteModal } from './LiteModal';

// useStyles

const useStyles = makeStyles({
	root: {
		display: 'inline-flex',
		justifyContent: 'space-between',
	},
	box: {
		display: 'flex',
		flexDirection: 'column',
		padding: 15,
	},
	text: {
		fontSize: 16,
		paddingTop: 8,
		width: '95%',
		'& .MuiTextField-root': {
			margin: 15,
		},
	},
});

// props
export type LiteCreateQRModalProps = {
	handleClose: () => void;
	open: boolean;
};

const LiteCreateQRModal = (props: LiteCreateQRModalProps) => {
	const { handleClose, open } = { ...props };
	// consts, methods, functions, useEffects, useState ect go here
	const classes = useStyles();
	const dispatch = useAppDispatch();
	const create = bindActionCreators(createNewRedirect, dispatch);
	const [name, setName] = useState('');
	const [url, setURL] = useState('');

	const handleCreate = () => {
		// make sure we have http at the beginning of the url
		if (!url.startsWith('http://') && !url.startsWith('https://')) {
			let tempUrl = 'https://' + url;
			create({ name, url: tempUrl });
		} else {
			create({ name, url });
		}
		handleClose();
	};

	return (
		<div className={classes.root}>
			<LiteModal
				title="Create QR Code"
				titleVariant="dark"
				open={open}
				handleClose={handleClose}
				actions={
					<>
						<FlatButton onClick={handleClose}>Cancel</FlatButton>
						<FlatButton variant="contained" color="primary" type="submit" onClick={handleCreate}>
							Save
						</FlatButton>
					</>
				}
			>
				<Box className={classes.box}>
					<Typography className={classes.text} variant="body2">
						{'Complete the fields below to generate a dynamic QR code.'}
					</Typography>
				</Box>

				<div className={classes.text}>
					<TextField
						label={'Link Name'}
						placeholder="My QR Code Nickname"
						id="pageSlug"
						variant="outlined"
						size="small"
						fullWidth
						autoFocus
						onChange={(e) => {
							setName(e.target.value);
						}}
						onKeyPress={(e) => {
							if (e.key === 'Enter') {
								handleCreate();
							}
						}}
					/>
					<TextField
						label="Link"
						placeholder="https://www.viiision.com"
						id="linkInput"
						variant="outlined"
						size="small"
						fullWidth
						onChange={(e) => {
							setURL(e.target.value);
						}}
						onKeyPress={(e) => {
							if (e.key === 'Enter') {
								handleCreate();
							}
						}}
					/>
				</div>
			</LiteModal>
		</div>
	);
};

export default LiteCreateQRModal;
